export default function addAnimationToFeatureImage() {
  const featureImages = document.querySelectorAll(".js-feature-image");

  const callback = function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {

        setTimeout(function() {
          if (entry.target.dataset.blockCount % 2) {
            entry.target.classList.add("motion-safe:animate-slideInRight");
          } else {
            entry.target.classList.add("motion-safe:animate-slideInLeft");
          }
        }, 500);
      }
    });
  };

  const observer = new IntersectionObserver(callback);
  featureImages.forEach(function(target) {
    // Hide the element
    target.classList.add("opacity-0");

    // Add the element to the watcher
    observer.observe(target);
  });
}
